<template>
  <div class="survey-index">
    <bread :breadResults="breadResults"></bread>

    <div v-if="detail" class="info">
      <div class="info-head">
        <img class="head-icon" :src="detail.cover | imgFilter" alt="">
        <div class="head-infos">
          <div class="infos-title">{{detail.title}}</div>
          <div class="infos-time">参与时间：{{detail.startTime}} 至 {{detail.endTime}}</div>
        </div>
        <div v-if="detail.isJoin === 0" class="head-btn">
          <span v-if="detail.status === 1" @click="handleLinkToSurveyPaper(1)">参与调研</span>
          <span v-if="detail.status === 2" @click="handleLinkToSurveyPaper(2)">参与调研</span>
          <span v-if="detail.status === 3">已结束</span>
        </div>
        <div v-if="detail.isJoin === 1" class="head-btn head-btn-other">
          <div>提交成功</div>
          <div>感谢您的参与!</div>
        </div>
      </div>

      <div class="info-remark">
        <div class="remark-head">
          <img class="head-icon" src="../../assets/images/icon_zhuangshi@2x.png" alt="">
          <div class="head-text">问卷须知</div>
        </div>
        <div v-if="detail && detail.intro" class="remark-content">{{detail.intro}}</div>
        <div v-else class="remark-content-blank">
          <img src="../../assets/images/blank.png" alt="">
          <div>暂无其他内容</div> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bread from '@/components/bread/index'
export default {
  name: 'SurveyIndex',
  components: {
    bread
  },
  data() {
    return {
      breadResults: [{title: '首页', to: '/index'}, {title: '培训', to: '/classroom/index'}, {title: '调研详情'}],
      detail: null
    }
  },
  activated() {
    this.handleGetDetail()
  },
  methods: {
    handleGetDetail() {
      this.$api.course.surveyDetail({id: this.$route.query.id}).then(res => {
        res.data.startTime = this.$util.changeFormat(res.data.startTime, '/', 'year', 'day')
        res.data.endTime = this.$util.changeFormat(res.data.endTime, '/', 'year', 'day')
        this.detail = res.data
        this.breadResults[2].title = res.data.title
      })
    },
    handleLinkToSurveyPaper(i){
      if(i === 1){
        return this.$confirm('未到调研时间，请您稍后参与。', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
      }
      if(i === 2){
        this.$router.push({path: '/surveyDetail', query: {id: this.$route.query.id}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/mixin.scss';
.survey-index{
  padding-bottom: .2rem;
  .info{
    .info-head{
      width: 12rem;
      height: 2rem;
      padding: .2rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      border-radius: .05rem;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
      margin-bottom: .2rem;
      .head-icon{
        width: 2.4rem;
        height: 1.6rem;
      }
      .head-infos{
        flex: 1;
        margin: 0 .2rem;
        .infos-title{
          font-size: .2rem;
          color: #2F354D;
        }
        .infos-time{
          font-size: .14rem;
          color: #72808E;
          margin-top: .1rem;
        }
      }
      .head-btn{
        min-width: 1rem;
        height: .3rem;
        text-align: center;
        line-height: .3rem;
        border: 1px solid #D7E2EC;
        border-radius: .03rem;
        font-size: .14rem;
        color: #0E3092;
        @include cur();
        &.head-btn-other{
          width: 1.2rem;
          height: .5rem;
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;
          line-height: .2rem;
        }
      }
    }

    .info-remark{
      .remark-head{
        display: flex;
        align-items: center;
        margin-bottom: .15rem;
        .head-icon{
          width: .34rem;
          height: .34rem;
          margin-right: .1rem;
        }
        .head-text{
          font-size: .18rem;
          color: #000;
        }
      }
      .remark-content{
        width: 12rem;
        padding: .2rem;
        background-color: #fff;
        border-radius: .05rem;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
        line-height: .24rem;
        font-size: .13rem;
        color: #3D3D3D;
      }
      .remark-content-blank{
        width: 12rem;
        height: 4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        background-color: #fff;
        border-radius: .05rem;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
        img{
          width: 1.51rem;
        }
        div{
          text-align: center;
          font-size: .14rem;
          font-weight: bold;
          color: #CCD1D9;
          margin-top: .2rem;
        }
      }
    }
  }
}
</style>

